var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{attrs:{"anchor-layout":_vm.layoutName}},[_c('v-container',{staticClass:"fill-height grey darken-4",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"8","md":"4"}},[(_vm.applicationLoaded)?_c('router-view'):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }